import React from "react";
import { PageSection } from "../../PageSection";
import PropTypes from "prop-types";

import * as styles from "./styles.module.scss";

/**
 * Renders all subscription actions in a section.
 * @param {object} props - The properties object.
 * @returns {React.JSX.Element|null} The rendered component or null if no lines are provided.
 * @constructor
 */
export const SubscriptionActionSection = ( props ) => {
	/**
	 * Returns the lines in displayable form for this the section.
	 * @param {Array} lines The actions to display.
	 * @returns {Array} The lines in displayable form.
	 */
	const getLines = ( lines ) => {
		return lines.reduce( ( acc, line, i ) => {
			if ( ! line ) {
				return acc;
			}
			acc.push(
				<div className={ styles.detailsLine } key={ `section-${ i }` }>
					{ line.action &&
						<div className={ styles.lineAction }>
							{ line.action }
						</div> }
				</div>,
			);
			return acc;
		}, [] );
	};

	if ( ! props.lines || ! props.lines.length ) {
		return null;
	}

	return (
		<PageSection title={ props.title }>
			<div className={ styles.subscriptionActionSection }>
				{ getLines( props.lines ) }
			</div>
		</PageSection>
	);
};

SubscriptionActionSection.propTypes = {
	title: PropTypes.string.isRequired,
	lines: PropTypes.arrayOf( PropTypes.shape( {
		action: PropTypes.node,
	} ) ),
};
